import { createSelector } from "reselect";

function selectAddresses(state) {
  return state.addresses;
}

const selectIsDev = createSelector(selectAddresses, (addresses) => {
  return addresses?.isDev;
});

const selectApiBase = createSelector(selectAddresses, (addresses) => {
  return addresses?.apiBase;
});

const selectIsTestingMode = createSelector(selectAddresses, (addresses) => {
  return addresses?.isTestingMode;
});

export { selectAddresses, selectIsDev, selectIsTestingMode, selectApiBase };
